import { Injectable } from '@angular/core';
import { Logger } from '@lib.core/logger/logger';
import { LogEntity, LogSeverity } from '@lib.core/logger/logger.service';

@Injectable({
  providedIn: 'root'
})
export class ConsoleLoggerService implements Logger {
  private minLoggingLevel = LogSeverity.Information;

  public setMinLoggingLevel(level: LogSeverity) {
    this.minLoggingLevel = level;
  }

  public log(logEntity: LogEntity) {
    if (logEntity.severity < this.minLoggingLevel) {
      return;
    }
    const message = logEntity.stack ?? logEntity.message;
    const severity = logEntity.severity;
    if (severity === LogSeverity.Fatal || severity === LogSeverity.Error) {
      console.error(message);
    } else if (severity === LogSeverity.Warning) {
      console.warn(message);
    } else {
      console.log(message);
    }
  }
}
